var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99984 7.29102C6.49561 7.29102 7.70817 8.50358 7.70817 9.99935C7.70817 11.4951 6.49561 12.7077 4.99984 12.7077C3.50407 12.7077 2.2915 11.4951 2.2915 9.99935C2.2915 8.50358 3.50407 7.29102 4.99984 7.29102ZM8.90911 9.37435C8.60945 7.48519 6.9733 6.04102 4.99984 6.04102C2.81371 6.04102 1.0415 7.81322 1.0415 9.99935C1.0415 12.1855 2.81371 13.9577 4.99984 13.9577C6.9733 13.9577 8.60945 12.5135 8.90911 10.6243H17.7082V12.4993C17.7082 12.8445 17.988 13.1243 18.3332 13.1243C18.6783 13.1243 18.9582 12.8445 18.9582 12.4993V9.99935C18.9582 9.65417 18.6783 9.37435 18.3332 9.37435H8.90911Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 9.37435C14.6547 9.37435 14.3748 9.65417 14.3748 9.99935V12.4993C14.3748 12.8445 14.6547 13.1243 14.9998 13.1243C15.345 13.1243 15.6248 12.8445 15.6248 12.4993V9.99935C15.6248 9.65417 15.345 9.37435 14.9998 9.37435Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.4b1edb1efc39e9c4bbb96e503454698e.svg";
export { ForwardRef as ReactComponent };